subscription ChatStreamUpdates($uuid: String!) {
  chatStreamUpdatesSubscription(uuid: $uuid) {
    events {
      type
      seq
      ... on SharingChatStreamEventTextDelta {
        content
        messageIndex
      }
      ... on SharingChatStreamEventMessageComplete {
        message {
          id
          content
          role
        }
        messageIndex
      }
      ... on SharingChatStreamEventError {
        errorMessage
      }
      ... on SharingChatStreamEventToolCallExecute {
        toolCallId
        toolName
        intent
        messageIndex
      }
      ... on SharingChatStreamEventToolCallResult {
        toolCallId
        toolName
        result
        messageIndex
      }
      ... on SharingChatStreamEventToolCallDelta {
        toolCallId
        toolName
        argumentDeltas {
          argumentName
          content
          sequenceNumber
        }
        messageIndex
      }
    }
  }
}
